import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { NotificationIcon } from './notification-icon';
import css from '../css/speed-dial.m.css';
const factory = create({ theme }).properties();
export const ActionButton = factory(({ id, children, properties, middleware: { theme } }) => {
    const { aria = {}, shouldFocus, disabled, widgetId, name, expanded, type = 'button', value, onClick, onOut, onOver, onDown, onKeyDown, onUp, onBlur, onFocus, title, size = 'large', isAction = false, isHighlighted = false } = properties();
    const idBase = widgetId || `button-${id}`;
    const themeCss = theme.classes(css);
    const buttonSize = size === 'large' ? themeCss.large : themeCss.small;
    const actionStyle = isAction ? [themeCss.action, themeCss.actionTransition] : [];
    aria['expanded'] = typeof expanded === 'boolean' ? expanded.toString() : null;
    return [
        v('button', {
            key: `${id}`,
            classes: [themeCss.button, buttonSize, ...actionStyle],
            title: title,
            disabled: disabled,
            id: idBase,
            focus: shouldFocus,
            name: name,
            type: type,
            value: value,
            onblur: () => onBlur && onBlur(),
            onclick: (event) => {
                onClick && onClick(event);
            },
            onfocus: () => onFocus && onFocus(),
            onpointerenter: () => onOver && onOver(),
            onpointerleave: () => onOut && onOut(),
            onpointerdown: () => onDown && onDown(),
            onpointerup: () => onUp && onUp(),
            onkeydown: (event) => onKeyDown && onKeyDown(event),
            ...formatAriaProperties(aria)
        }, [v('span', { classes: [themeCss.label] }, children())]),
        isHighlighted ? w(NotificationIcon, {}) : null
    ];
});
